import { AxiosInstance } from "axios";
import { SwitchboardApiBase } from "./SwitchboardApiBase";
import { SwitchboardConfig } from "@Models/SwitchboardConfig";

export class ApplicationSettingsSharedApi extends SwitchboardApiBase {
    constructor(config: SwitchboardConfig, axios: AxiosInstance) {
        super(config, axios);
    }
}
